<template>
  <div>
    <search @submit="submitSearch" />

    <a-table
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    >
      <span slot="actions" slot-scope="text, record">
        <a-space>
          <a @click="send(record.id)">发送确认单</a>
          <a @click="showImg(record.id)">确认单详情</a>
          <a @click="showDetails(record.id)">查看发送记录</a>
        </a-space>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <preview-image
      :visible.sync="previewVisible"
      :image.sync="previewImage"
    />

    <show-details
      v-if="isShowDetailsModal"
      :visible.sync="isShowDetailsModal"
      :id="recordId"
    />

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { findConfirmationFormSendRecord, sendConfirmationForm, findConfirmationFormSendRecordPicture } from '@/api/confirmation_form_send_record'
import Search from '@/views/confirmation_form_send_records/Search'
import PreviewImage from '@/components/PreviewImage'

export default {
  name: 'ConfirmationFormSendRecordList',
  components: {
    Pagination,
    PreviewImage,
    Search,
    ShowDetails: () => import('@/views/confirmation_form_send_records/Details')
  },
  data() {
    return {
      query: {},
      data: [],
      loading: true,
      isShowSendModal: false,
      isShowDetailsModal: false,
      pagination: {
        total_count: 0
      },
      previewVisible: false,
      previewImage: '',
      recordId: 0
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    columns() {
      return [
        {
          title: '订单编号',
          dataIndex: 'order_no'
        },
        {
          title: '逝者姓名',
          dataIndex: 'dead_name'
        },
        {
          title: '申请人',
          dataIndex: 'apply_name'
        },
        {
          title: '联系电话',
          dataIndex: 'apply_phone'
        },
        {
          title: '订单状态',
          dataIndex: 'order_status'
        },
        {
          title: '最近发送时间',
          dataIndex: 'send_at'
        },
        {
          title: '查看状态',
          dataIndex: 'status'
        },
        {
          title: '操作',
          dataIndex: 'actions',
          width: 300,
          fixed: 'right',
          scopedSlots: { customRender: 'actions' }
        }
      ]
    }
  },
  methods: {
    send(id) {
      sendConfirmationForm(id, {}).then()
    },

    showImg(id) {
      this.previewVisible = true
      findConfirmationFormSendRecordPicture(id, {}).then((res) => {
        if (res.code === 0) {
          this.previewImage = res.data.url
        }
      })
    },

    showDetails(id) {
      this.recordId = id
      this.isShowDetailsModal = true
    },

    submitSearch(search) {
      // 重置排序
      this.sort = this.$options.data().sort
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findConfirmationFormSendRecord(Object.assign({}, this.query)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
